import { useState, useCallback } from "react";

import ErrorToast from "../components/toast/ErrorToast"; // ErrorToast 컴포넌트 경로 확인 필요

interface CopyToClipboardProps {
  text: string;
  isRepeatable?: boolean;
}

export function useCopyToClipboard(timeout = 300) {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = useCallback(
    async ({ text, isRepeatable = true }: CopyToClipboardProps) => {
      if (!navigator.clipboard) {
        // 클립보드 API 지원 안 함
        console.error("Clipboard API not supported");
        ErrorToast({
          title: "Clipboard not supported",
          description: "Your browser does not support clipboard operations.",
        });
        return;
      }

      try {
        await navigator.clipboard.writeText(text);
        setIsCopied(true);

        if (!isRepeatable) {
          // 반복 복사 방지 시 여기서 종료
          return;
        }

        // 지정된 시간 후에 isCopied 상태를 false로 되돌림
        const timer = setTimeout(() => {
          setIsCopied(false);
        }, timeout);

        // 컴포넌트 언마운트 시 타이머 클리어 (메모리 누수 방지)
        return () => clearTimeout(timer);
      } catch (error) {
        console.error("Failed to copy text: ", error);
        setIsCopied(false);
        ErrorToast({
          title: "Failed to copy",
          description: "Could not copy text to clipboard.",
        });
      }
    },
    [timeout], // timeout 값이 변경될 때만 함수 재생성
  );

  return { isCopied, copyToClipboard };
}
